import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import type Producer from '@/types/Producer'
import type PaginatedResponse from '@/types/PaginatedResponse'
import { useProducerStore } from '@/stores/producer'
import type Event from '@/types/Event'
import type DataResponse from '@/types/DataResponse'

export default class ProducerService {
  async events(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Event>>> {
    const producer = useProducerStore().producer?.id

    return await http.get<PaginatedResponse<Event>>(`/api/v1/office/producers/${producer}/events?page=${page}&${filters}&per_page=${per_page}`)
  }

  async index(page: number, filters: string, per_page: number | undefined = 10): Promise<AxiosResponse<PaginatedResponse<Producer>>> {
    return await http.get<PaginatedResponse<Producer>>(`/api/v1/office/producers?page=${page}&${filters}&per_page=${per_page}`)
  }

  async show(id: string) {
    return await http.get<Producer>(`/api/v1/office/producers/${id}`)
  }

  async store(model: Producer) {
    const headers = { 'Content-Type': 'multipart/form-data' }
    return await http.post<DataResponse<Producer>>(`/api/v1/office/producers`, model, { headers })
  }

  async update(id: string, model: Producer) {
    const headers = { 'Content-Type': 'multipart/form-data' }

    // https://laravel.com/docs/11.x/routing#form-method-spoofing
    // @ts-expect-error applying method spoofing on object
    model._method = 'put'

    return await http.post<DataResponse<Producer>>(`/api/v1/office/producers/${id}`, model, { headers })
  }

  async destroy(id: string) {
    return await http.delete(`/api/v1/office/producers/${id}`)
  }

  async restore(id: string) {
    return await http.delete(`/api/v1/office/producers/deleted/${id}`)
  }
}
